import { Injectable, isDevMode } from '@angular/core';
import { Observable } from 'rxjs';
import { BoDaoService } from 'src/app/dao/bo-dao-service/bo-dao.service';
import { APP_CONFIG } from 'src/app/config';
import * as semver from 'semver';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { map } from 'rxjs/internal/operators/map';
@Injectable({
  providedIn: 'root'
})
export class BoService {

  APP_CONFIG;
  browserLang: string;

  constructor(private boDaoService: BoDaoService,
    private userStorageService: UserStorageService) {
    this.APP_CONFIG = APP_CONFIG;
  }

  public getVersion() {
    return this.boDaoService.getVersion(this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
      map(o => o['data']['versionBO'])
    );
  }

  public newVersionAvailable() {
    if (semver.gt(this.userStorageService.getBOVersion(), APP_CONFIG.appVersion)) {
      return true;
    } else if (semver.lt(this.userStorageService.getBOVersion(), APP_CONFIG.appVersion)) {
      console.warn('MSHOP: Backoffice version overtaking');
      return false;
    } else if (semver.eq(this.userStorageService.getBOVersion(), APP_CONFIG.appVersion)) {
      return false;
    } else {
      return false;
    }
  }

  public getLanguage() {
    this.browserLang = navigator.language;
    if (this.browserLang !== null) {
      switch (true) {
        case (/es/).test(this.browserLang):
          return 'es_ES';
        case (/de/).test(this.browserLang):
          return 'de_DE';
        case (/fr/).test(this.browserLang):
          return 'fr_FR';
        case (/pt/).test(this.browserLang):
          return 'pt_PT';
        case (/el/).test(this.browserLang):
          return 'el_GR';
        case (/tr/).test(this.browserLang):
          return 'tr_TR';
        default:
          return 'en_GB';
      }
    }
  }
}
